import {
  SEARCH_COLLECTORS,
  SEARCH_COLLECTORS_SUCCESS,
  AUTOCOMPLETE_COLLECTORS,
  AUTOCOMPLETE_COLLECTORS_SUCCESS,
  GET_COLLECTOR,
  GET_COLLECTOR_SUCCESS,
  GET_COLLECTOR_ERROR,
  GET_COLLECTOR_CLIENTS,
  GET_COLLECTOR_CLIENTS_SUCCESS,
  ADD_CLIENT_TO_COLLECTOR_SUCCESS,
  REMOVE_CLIENT_FROM_COLLECTOR_SUCCESS,
  UPDATE_COLLECTOR_RECIPIENTS,
  UPDATE_COLLECTOR_RECIPIENTS_SUCCESS,
  UPDATE_COLLECTOR_RECIPIENTS_ERROR,
} from '../constants/ActionsTypes'

const initialState = {
  collectorList: [],
  collector: null,
  collectorClients: {
    data: [],
    metadata: null,
  },
  autocompleteData: null,
  search: {},
  searchRequest: {},
  searchClientsRequest: {},
  isRecipientsSaved: false,
}

function rootReducer(state = initialState, action) {
  switch (action.type) {
    case SEARCH_COLLECTORS:
      return { ...state, searchRequest: action.payload }
    case SEARCH_COLLECTORS_SUCCESS:
      return { ...state, search: action.payload.response, collectorList: action.payload.data }
    case AUTOCOMPLETE_COLLECTORS:
      return { ...state, autocompleteData: null }
    case AUTOCOMPLETE_COLLECTORS_SUCCESS:
      return { ...state, autocompleteData: action.payload }
    case GET_COLLECTOR:
      return { ...state, collector: null }
    case GET_COLLECTOR_SUCCESS:
      return { ...state, collector: action.payload.data }
    case GET_COLLECTOR_ERROR:
      return { ...state, collector: null }
    case GET_COLLECTOR_CLIENTS:
      return { ...state, searchClientsRequest: action.payload.params }
    case GET_COLLECTOR_CLIENTS_SUCCESS:
      return {
        ...state,
        collectorClients: {
          data: action.payload.data || [],
          metadata: action.payload.metadata || null,
        },
      }
    case ADD_CLIENT_TO_COLLECTOR_SUCCESS:
    case REMOVE_CLIENT_FROM_COLLECTOR_SUCCESS:
      return state
    case UPDATE_COLLECTOR_RECIPIENTS:
      return { ...state, isRecipientsSaved: false }
    case UPDATE_COLLECTOR_RECIPIENTS_SUCCESS:
      return { ...state, isRecipientsSaved: true }
    case UPDATE_COLLECTOR_RECIPIENTS_ERROR:
      return { ...state, isRecipientsSaved: false }
    default:
      return state
  }
}

export default rootReducer
